import { Controller } from "@hotwired/stimulus";
import gsap from "gsap";

// Connects to data-controller="greeting-card-popup"
export default class extends Controller {
    static targets = ["background", "content", "previewThemeWrapper", "priceWrapper"];

    connect() {
    }

    onThemeSelect = (e) => {
        if (this.themeTransitionTl && this.themeTransitionTl.isActive()) {
            this.themeTransitionTl.kill();
        }

        if (this.priceTransitionTl && this.priceTransitionTl.isActive()) {
            this.priceTransitionTl.kill();
        }

        this.themeTransitionTl = gsap.timeline({
            onComplete: () => {
                const themes = Array.from(this.previewThemeWrapperTarget.querySelectorAll("img"));

                if (themes && themes.length > 1) {
                    themes.slice(0, -1).forEach((element) => {
                        element.remove();
                    })
                }
            }
        });

        this.priceTransitionTl = gsap.timeline({
            onComplete: () => {
                const prices = Array.from(this.priceWrapperTarget.querySelectorAll("span"));
                if (prices && prices.length > 1) {
                    prices.slice(0, -1).forEach((element) => {
                        element.remove();
                    })
                }
            }
        });

        let img = document.createElement('img');
        img.src = e.srcElement.dataset.img;

        img.className = "w-full h-full top-0 left-0 absolute object-contain object-center opacity-0";
        this.previewThemeWrapperTarget.appendChild(img);

        let price = document.createElement('span');
        price.innerHTML = e.srcElement.dataset.price;

        price.className = "text-base leading-[1.375rem] font-bold top-0 right-0 absolute opacity-0";
        this.priceWrapperTarget.appendChild(price);

        const themes = Array.from(this.previewThemeWrapperTarget.querySelectorAll("img"));
        if (themes && themes.length > 1) {
            this.themeTransitionTl.to(themes.slice(0, -1), { opacity: 0, duration: 0.3 });
        }
        this.themeTransitionTl.to(img, { opacity: 1, duration: 0.3 }, "<");

        const prices = Array.from(this.priceWrapperTarget.querySelectorAll("span"));
        if (prices && prices.length > 1) {
            this.priceTransitionTl.to(prices.slice(0, -1), { opacity: 0, duration: 0.3 });
        }
        this.priceTransitionTl.to(price, { opacity: 1, duration: 0.3 }, "<");
    }

    openPopup() {
        document.body.classList.add("--popup-opened");
        gsap.to(this.element, { display: "flex", duration: 0 });
        gsap.to(this.backgroundTarget, { duration: 0.25, opacity: 1 });
        gsap.to(this.contentTarget, { delay: 0.1, duration: 0.25, opacity: 1 });
        gsap.delayedCall(0.01, () => this.element.classList.add("fade-in--manual", "fade-in-childs--manual"));
    }

    closePopup(e) {
        e.preventDefault();
        document.body.classList.remove("--popup-opened");
        gsap.to(this.contentTarget, { duration: 0.35, opacity: 0 });
        gsap.to(this.backgroundTarget, { delay: 0.2, duration: 0.35, opacity: 0 });
        gsap.to(this.element, { delay: 0.55, display: "none", duration: 0 });
        gsap.delayedCall(0.55, () => {
            this.element.classList.remove("fade-in--manual", "fade-in-childs--manual");
        });
    }

    disconnect() { }
}
